export default __webpack_public_path__ + "7f3b211f839e0ecb0e368620de97aff1.woff2";